const postcssConfigContent = String.raw`const config = {
  plugins: {
    "@tailwindcss/postcss": {},
  },
};

export default config;`;

export default postcssConfigContent;
